"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toError = void 0;
var object_1 = require("@wix/wix-vod-shared/dist/src/common/utils/object");
var transport_error_1 = require("./transport-error");
function toError(error) {
    var _a;
    var errorResponse = error.response;
    var status = errorResponse.status, message = errorResponse.statusText, _b = errorResponse.data, data = _b === void 0 ? {} : _b;
    var url = (_a = error.config) === null || _a === void 0 ? void 0 : _a.url;
    var camelCasedData = (0, object_1.keysToCamelCase)(data);
    var errorCode = camelCasedData.errorCode, errorDescription = camelCasedData.errorDescription;
    return Promise.reject(new transport_error_1.TransportError(status, url, {
        code: errorCode,
        data: camelCasedData,
        message: errorDescription || message,
    }));
}
exports.toError = toError;
//# sourceMappingURL=to-error.js.map